<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-12 18:37:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-19 17:49:16
-->
<template>
  <div class="d-flex flex-column"
       style="height:100%;">
    <!-- <div class="d-flex"
         style="height:56px;background-color:#ffffff">
      <logo />
      <topAside style="flex: 1" />
    </div> -->
    <v-app-bar color="#ffffff"
               class="pa-0"
               height="56"
               style="border-bottom:1px solid #dedede"
               :clipped-left="$vuetify.breakpoint.lgAndUp"
               app
               elevation='0'
               dark>
      <div class="d-flex"
           style="width:100%;">
        <logo />
        <topAside style="flex: 1">
          <template v-slot:btnDrawer>
            <div class="d-flex">
              <v-btn class="icon"
                     @click.stop="changeDrawer"
                     icon>
                <mrc_ess_svgIcon icon-class="service"
                                 style="font-size:24px" />
              </v-btn>
              <breadcrumbs class="ml-3" />
            </div>
          </template>
        </topAside>
      </div>
    </v-app-bar>
    <v-divider></v-divider>
    <sidebarNav ref="menu" />
    <v-main>
      <contentView />
    </v-main>
    <!-- <div class="d-flex">
    
      <contentView style="flex: 1;" />
    </div> -->
    <!-- <div style="font-size:12px;color:rgba(0,0,0,0.38);height:50px;line-height:50px;text-align:center;">
      <div>
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved.
        <a href="
         https://privacy.essencehr.io/"
           target="_blank"
           style="color:var(--main-color);text-decoration: none">Privacy Policy</a>
        and
        <a href="https://terms.essencehr.io/"
           target="_blank"
           style="color:var(--main-color);text-decoration: none">Term of Use.</a>
      </div>
    </div> -->
    <!-- :style="{left:$store.state.miniVariant?'':'calc(50% - 240px)'}" -->
    <!-- position:absolute;bottom:0;width:100%;transform: translateX(50%);left:50%;" -->

  </div>
</template>

<script>
import breadcrumbs from './main-content/breadcrumds.vue'
import mainContent from './main-content/index'
// import sidebarNav from './sidebar-nav'
import sidebarNav from './sideMenu'
import logo from './logo'
import contentView from './main-content/content'
import topAside from './main-content/top-aside/index'
export default {
  components: {
    mainContent,
    sidebarNav,
    logo,
    topAside,
    contentView,
    breadcrumbs
  },
  computed: {},
  methods: {
    changeDrawer () {
      this.$refs.menu.changeDrawer()
    }
  }
}
</script>

<style scoped>
/* .mainClass {
  overflow: hidden;
} */
.rightArea {
  flex: 1;
  height: 100%;
  overflow: auto;
}
</style>
